import type { CSSProperties } from "react";
import "../../Styles/Message/ResearchActivityDisplay.css";

const CELL_DELAYS = Array.from({ length: 9 }, (_, index) => {
    const row = Math.floor(index / 3);
    const column = index % 3;
    return (column + Math.abs(row - 1)) * 90;
});

export const MessageLoadingIndicator = () => (
    <span className="message-loading-grid" aria-hidden="true">
        {CELL_DELAYS.map((delay, index) => (
            <span
                key={index}
                className="message-loading-cell"
                style={{ "--message-loading-delay": `${delay}ms` } as CSSProperties}
            />
        ))}
    </span>
);

export const MessageLoadingState = ({
    label = "Thinking",
    inline = false,
}: {
    label?: string;
    inline?: boolean;
}) => {
    return (
        <span
            className={`message-loading-state${inline ? " is-inline" : ""}`}
            role={inline ? undefined : "status"}
            aria-label={inline ? undefined : label}
            aria-busy={inline ? undefined : "true"}
            aria-hidden={inline ? "true" : undefined}
        >
            <MessageLoadingIndicator />
            <span className="message-loading-label" aria-hidden="true">
                {label}
            </span>
        </span>
    );
};
